<template>
  <Dialog :open="modelValue" @update:open="handleOpenChange">
    <DialogContent
      :class="[
        'tw-max-h-[90vh] tw-overflow-hidden tw-flex tw-flex-col',
        props.extraClass || 'tw-max-w-md tw-min-w-80',
        !closeOnBackdrop ? 'tw-pointer-events-auto' : '',
      ]"
      @interact-outside="handleInteractOutside"
    >
      <!-- Header -->
      <DialogHeader class="tw-flex-shrink-0">
        <DialogTitle>{{ title }}</DialogTitle>
      </DialogHeader>

      <!-- Body -->
      <div class="tw-flex-1 tw-overflow-auto tw-py-4 tw-px-1">
        <slot name="body">
          <slot></slot>
        </slot>
      </div>

      <!-- Footer -->
      <DialogFooter class="tw-flex-shrink-0">
        <slot name="footer"></slot>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
  DialogFooter,
} from '@/components/ui/dialog';

interface Props {
  modelValue: boolean;
  title?: string;
  closable?: boolean;
  closeOnBackdrop?: boolean;
  extraClass?: string;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}

const props = withDefaults(defineProps<Props>(), {
  closable: true,
  closeOnBackdrop: false,
});

const emit = defineEmits<Emits>();

const handleOpenChange = (open: boolean) => {
  emit('update:modelValue', open);
  if (!open) {
    emit('close');
  }
};

const handleInteractOutside = (event: Event) => {
  if (!props.closeOnBackdrop) {
    event.preventDefault();
  }
};
</script>
